import React, { useState, useEffect } from "react";
import { Switch, useHistory } from "react-router-dom";
import { useSelector } from "react-redux";

import ListSimulation from "../Pages/listSimulations";
import ClientData from "../Pages/clientData";
import WorkData from "../Pages/workData";
import HealthStatement from "../Pages/healthStatement";
import Beneficiaries from "../Pages/beneficiaries";
import AdditionalInfoPart1 from "../Pages/additionalInfoPart1";
import AdditionalInfoPart2 from "../Pages/additionalInfoPart2";
import VerifySimulation from "../Pages/verifySimulation";
import { OffLine } from "../Pages/wizard/OffLine";
import { ProtectedRoute } from "./privateRoute";
import { DetailPageRVEO } from "../Pages/wizard/DetailPageRVEO";

function NestedRouters({ path }) {
  const history = useHistory();
  const modules = useSelector((state) => state.login.access_configuration.modules);
  const granted = useSelector((state) => state.login.granted);

  const [isInline, setisInline] = useState(true);

  useEffect(() => {
    const handleOnline = () => {
      setisInline(true);
    };

    const handleOffline = () => {
      setisInline(false);
      history.push("/cotizaciones/sin-conexion");
    };

    window.addEventListener("online", handleOnline);
    window.addEventListener("offline", handleOffline);

    return () => {
      window.removeEventListener("online", handleOnline);
      window.removeEventListener("offline", handleOffline);
    };
  }, [history]);
  return (
    <Switch>
      <ProtectedRoute
        exact
        path={path}
        component={ListSimulation}
        granted={granted}
        modules={modules}
      />
      <ProtectedRoute
        exact
        path={path + "/datos-cliente"}
        component={ClientData}
        modules={modules}
        granted={granted}
      />
      <ProtectedRoute
        exact
        path={path + "/datos-laborales"}
        component={WorkData}
        modules={modules}
        granted={granted}
      />
      <ProtectedRoute
        exact
        path={path + "/declaracion-de-salud"}
        component={HealthStatement}
        modules={modules}
        granted={granted}
      />
      <ProtectedRoute
        exact
        path={path + "/beneficiarios"}
        component={Beneficiaries}
        modules={modules}
        granted={granted}
      />
      <ProtectedRoute
        exact
        path={path + "/info-complementaria-1"}
        component={AdditionalInfoPart1}
        modules={modules}
        granted={granted}
      />
      <ProtectedRoute
        exact
        path={path + "/info-complementaria-2"}
        component={AdditionalInfoPart2}
        modules={modules}
        granted={granted}
      />
      <ProtectedRoute
        exact
        path={path + "/verificacion"}
        component={VerifySimulation}
        modules={modules}
        granted={granted}
      />
      <ProtectedRoute
        exact
        path={path + "/detalle"}
        component={DetailPageRVEO}
        modules={modules}
        granted={granted}
      />

      <ProtectedRoute
        exact
        path={"/cotizaciones/sin-conexion"}
        component={OffLine}
        modules={modules}
        granted={granted}
      />
    </Switch>
  );
}

//en este componente agregamos las rutas que corresponden a la ruta "/SIMULACIONES", de esta manera agregamos en el la siguiente ruta
// como es el ejempplo de "/cliente_data" .

export default NestedRouters;
